import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Logo from "../Assets/logo.png";

const PurchasePrint = () => {
    const [purchaseData, setPurchaseData] = useState(null);
    const { id } = useParams();

    const dummyPurchases = [
        {
            id: 1,
            purchase_id: "PUR-001",
            purchase_date: "2025-11-21",
            supplier_detail: {
                name: "SSS Enterprises",
                telephone: "9876543210",
                address: "123 Main Street, Bangalore",
                state: "Karnataka",
                tax_number: "29ABCDE1234F1Z5"
            },
            seller_detail: {
                shop_name: "SDS POLYTECHNIC",
                address: "College Road, Campus Area",
                city: "Coimbatore",
                state: "Tamil Nadu",
                pincode: "641012",
                phone: "0422-1234567",
                email: "admin@sdpolytechnic.edu.in",
                gst_no: "33ABCDE1234F1Z5"
            },
            items: [
                {
                    id: 1,
                    product_name: "Pin Box - (00:4)",
                    amount_per_product: 180.0,
                    qty: 73,
                    unit: "PCS",
                    total_per_product: 13140.0
                },
                {
                    id: 2,
                    product_name: "Notebook A4 Size",
                    amount_per_product: 45.5,
                    qty: 100,
                    unit: "PCS",
                    total_per_product: 4550.0
                },
                {
                    id: 3,
                    product_name: "Blue Pen",
                    amount_per_product: 12.0,
                    qty: 200,
                    unit: "PCS",
                    total_per_product: 2400.0
                }
            ],
            subtotal: 20090.0,
            gst_percentage: 18,
            gst_amount: 3616.2,
            total: 23706.2
        }
    ];

    useEffect(() => {
        const found = dummyPurchases.find(p => p.id === parseInt(id));
        if (found) setPurchaseData(found);

        setTimeout(() => window.print(), 800);
    }, [id]);

    if (!purchaseData) return null;

    const numberToWords = (num) => {
        if (num === 0) return "Zero";

        const ones = [
            "", "One", "Two", "Three", "Four", "Five", "Six", "Seven",
            "Eight", "Nine", "Ten", "Eleven", "Twelve", "Thirteen",
            "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"
        ];

        const tens = [
            "", "", "Twenty", "Thirty", "Forty", "Fifty",
            "Sixty", "Seventy", "Eighty", "Ninety"
        ];

        const convertBelowThousand = (n) => {
            if (n < 20) return ones[n];
            if (n < 100)
                return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
            return ones[Math.floor(n / 100)] + " Hundred" +
                (n % 100 ? " and " + convertBelowThousand(n % 100) : "");
        };

        let integer = Math.floor(num);
        let decimal = Math.round((num - integer) * 100);

        let result = "";

        let crore = Math.floor(integer / 10000000);
        let lakh = Math.floor((integer % 10000000) / 100000);
        let thousand = Math.floor((integer % 100000) / 1000);
        let hundred = integer % 1000;

        if (crore) result += convertBelowThousand(crore) + " Crore ";
        if (lakh) result += convertBelowThousand(lakh) + " Lakh ";
        if (thousand) result += convertBelowThousand(thousand) + " Thousand ";
        if (hundred) result += convertBelowThousand(hundred);

        result = result.trim();

        if (decimal > 0) {
            result += ` and ${convertBelowThousand(decimal)} Paise`;
        }

        return result + " Only";
    };

    return (
        <div className="print-page">

            {/* FULL PAGE BORDER */}
            <div className="page-border"></div>

            <div className="print-content">

                {/* HEADER */}
                <div className="header-section">
                    <div>GSTIN No: {purchaseData.seller_detail.gst_no}</div>
                    <div className="title">Purchase Bill</div>
                </div>

                {/* COMPANY BLOCK */}
                <div className="company-section">
                    <img src={Logo} width="70" alt="logo" />

                    <div className="company-details">
                        <h2>{purchaseData.seller_detail.shop_name}</h2>
                        <div>{purchaseData.seller_detail.address}</div>
                        <div>
                            {purchaseData.seller_detail.city},{" "}
                            {purchaseData.seller_detail.state} -{" "}
                            {purchaseData.seller_detail.pincode}
                        </div>
                        <div>Mobile: {purchaseData.seller_detail.phone}</div>
                    </div>
                </div>

                {/* BILL INFO */}
                <div className="bill-info">
                    <div><b>Bill No:</b> {purchaseData.purchase_id}</div>
                    <div><b>Date:</b> {purchaseData.purchase_date}</div>
                </div>

                {/* SUPPLIER INFO */}
                <div className="customer-info">
                    <b>Supplier:</b> {purchaseData.supplier_detail.name},
                    {purchaseData.supplier_detail.address},
                    {purchaseData.supplier_detail.state},
                    GST: {purchaseData.supplier_detail.tax_number},
                    Ph: {purchaseData.supplier_detail.telephone}
                </div>

                {/* TABLE */}
                <table className="items-table">
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Product Name</th>
                            <th>Rate</th>
                            <th>Qty</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {purchaseData.items.map((item, index) => (
                            <tr key={item.id}>
                                <td>{index + 1}</td>
                                <td>{item.product_name}</td>
                                <td>{item.amount_per_product.toFixed(2)}</td>
                                <td>{item.qty} {item.unit}</td>
                                <td>₹ {item.total_per_product.toFixed(2)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {/* TOTALS */}
                <div className="totals-section">
                    <div>Sub Total: ₹ {purchaseData.subtotal.toFixed(2)}</div>
                    <div>GST ({purchaseData.gst_percentage}%): ₹ {purchaseData.gst_amount.toFixed(2)}</div>
                    <div className="grand-total">Grand Total: ₹ {purchaseData.total.toFixed(2)}</div>
                </div>

                {/* AMOUNT IN WORDS */}
                <div className="amount-words">
                    <b>Amount Chargeable (in words):</b>{" "}
                    {numberToWords(Math.round(purchaseData.total)).toUpperCase()}
                </div>

                {/* SIGNATURE */}
                <div className="signature-section">
                    <b>For {purchaseData.seller_detail.shop_name}</b>
                    <br /><br /><br />
                    <b>Authorized Signature</b>
                </div>

                <div className="footer-text">
                    This is a Computer Generated Purchase Bill
                </div>
            </div>
        </div>
    );
};

export default PurchasePrint;